export const selectCafes = state => state.cafeList;

